export enum MediaGroup {
    All = 'all',
    ListingPhotos = 'listingPhotos',
    ListingFloorplans = 'listingFloorplans',
    PropertyPhotos = 'propertyPhotos',
    PropertyFloorplans = 'propertyFloorplans',
    Videos = 'videos',
    VirtualTours = 'virtualTours',
}